// @flow
import NotFoundRoute from './NotFoundRoute'

export default NotFoundRoute
